import { Action, createReducer, on } from '@ngrx/store';
import { IConstantsResponseItems } from '@modules/sanna/data/models/constants.interface';
import { IDiagnosticosDatosItem } from '@shared/interfaces/diagnosticos-api.interface';
import { IEspacialidades } from '@sanna/data/models/sanna-ciudadano-api.interface';
import { IContingenciasItem } from '@sanna/data/models/sanna-contingencias-api.interface';
import {
  ICrearFormularioEmpleadorLicenciaBody,
  ILicenciaObtenerItem,
  ICrearLicenciaContingencia,
} from '@sanna/data/models/sanna-licencia-api.interface';
import { ILS, ILSENTITY, ILSValidationAdmin } from '@sanna/data/models/sanna.interfaces';

import {
  LOAD_SANNA_LICENCES,
  LOAD_SANNA_LICENCES_SUCCESS,
  LOAD_SANNA_LICENCES_FAIL,
  LOAD_SANNA_LICENCES_TO_DIGITIZE,
  LOAD_SANNA_LICENCES_TO_DIGITIZE_FAIL,
  LOAD_SANNA_LICENCES_TO_DIGITIZE_SUCCESS,
  LOAD_SANNA_LICENCES_TO_TYPE,
  LOAD_SANNA_LICENCES_TO_TYPE_FAIL,
  LOAD_SANNA_LICENCES_TO_TYPE_SUCCESS,
  LOAD_SANNA_LICENCES_CONSTANTS,
  LOAD_SANNA_LICENCES_CONSTANTS_SUCCESS,
  LOAD_SANNA_LICENCES_CONSTANTS_FAIL,
  LOAD_SANNA_LICENSE_FAIL,
  LOAD_SANNA_LICENSE_SUCCESS,
  LOAD_SANNA_LICENSE,
  LOAD_SANNA_DIAGNOSTIC,
  LOAD_SANNA_DIAGNOSTIC_SUCCESS,
  LOAD_SANNA_DIAGNOSTIC_FAIL,
  LOAD_SANNA_CONTINGENCIES_SUCCESS,
  LOAD_SANNA_CONTINGENCIES_FAIL,
  LOAD_SANNA_CONTINGENCIES,
  SELECT_SANNA_CONTINGENCIES,
  LOAD_SANNA_LICENCES_VALIDATION_ADMIN,
  LOAD_SANNA_LICENCES_VALIDATION_ADMIN_SUCCESS,
  LOAD_SANNA_LICENCES_VALIDATION_ADMIN_FAIL,
  LOAD_SANNA_LICENCES_TO_VALIDATE,
  LOAD_SANNA_LICENCES_TO_VALIDATE_SUCCESS,
  LOAD_SANNA_LICENCES_TO_VALIDATE_FAIL,
  LOAD_MEDICAL_SPECIALITY_SUCCESS,
  LOAD_MEDICAL_SPECIALITY,
  LOAD_MEDICAL_SPECIALITY_FAIL,
  LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT,
  LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT_SUCCESS,
  LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT_FAIL,
  LOAD_SANNA_VALIDATION_COMPTROLLER,
  LOAD_SANNA_VALIDATION_COMPTROLLER_FAIL,
  LOAD_SANNA_VALIDATION_COMPTROLLER_SUCCESS,
  LOAD_SANNA_VALIDATION_PRESIDENT,
  LOAD_SANNA_VALIDATION_PRESIDENT_SUCCESS,
  LOAD_SANNA_VALIDATION_PRESIDENT_FAIL,
  LOAD_SANNA_ZONE_C,
  LOAD_SANNA_ZONE_C_SUCCESS,
  LOAD_SANNA_ZONE_C_FAIL,
  LOAD_SANNA_DCN_REFERRER,
  LOAD_SANNA_DCN_REFERRER_SUCCESS,
  LOAD_SANNA_DCN_REFERRER_FAIL,
  LOAD_SANNA_PAYING_ENTITY_CONSULTATION,
  LOAD_SANNA_PAYING_ENTITY_CONSULTATION_SUCCESS,
  LOAD_SANNA_PAYING_ENTITY_CONSULTATION_FAIL,
  LOAD_SANNA_ABSTRACT_RESOL_CONSUL,
  LOAD_SANNA_ABSTRACT_RESOL_CONSUL_SUCCESS,
  LOAD_SANNA_ABSTRACT_RESOL_CONSUL_FAIL,
  LOAD_SANNA_PAYING_ENTITY_PROCESSING,
  LOAD_SANNA_PAYING_ENTITY_PROCESSING_SUCCESS,
  LOAD_SANNA_PAYING_ENTITY_PROCESSING_FAIL,
} from '@store/actions';
import {
  abstractResolutionConsultationResponse,
  abstractResolutionConsultationResponseItem,
} from '@modules/sanna/interface/abstract.interface';

export interface SannaState {
  lsRecordsWithoutProcessing: ILS[];
  loaded: boolean;
  loading: boolean;
  error: any;
  lsRecords?: ILS[];
  constants?: IConstantsResponseItems[];
  license?: ILicenciaObtenerItem[];
  diagnostics?: IDiagnosticosDatosItem[];
  contingencies?: IContingenciasItem[];
  selectedContingencies?: ICrearLicenciaContingencia;
  lsRecordsValidationAdmin: ILSValidationAdmin[];
  lsValidationRecords?: ILS[];
  specialties?: IEspacialidades;
  lsValidationComptrollerSupport?: ILS[];
  lsValidationComptroller?: ILS[];
  lsValidationPresident?: ILS[];
  lsZoneC?: ICrearFormularioEmpleadorLicenciaBody;
  lsDcnReferrer?: ILS[];
  LsPayingEntityConsultation?: ILSENTITY[];
  LsPayingEntityProcessing?: ILSENTITY[];
  LsAbstractResolutionConsultation?: abstractResolutionConsultationResponseItem[];
}

export const sannaInitialState: SannaState = {
  lsRecordsWithoutProcessing: [],
  loaded: false,
  loading: false,
  error: null,
  lsRecords: [],
  constants: [],
  license: [],
  diagnostics: [],
  contingencies: [],
  selectedContingencies: null,
  lsRecordsValidationAdmin: [],
  lsValidationRecords: [],
  specialties: null,
  lsValidationComptrollerSupport: [],
  lsValidationComptroller: [],
  lsValidationPresident: [],
  lsZoneC: null,
  lsDcnReferrer: [],
  LsPayingEntityConsultation: [],
  LsPayingEntityProcessing: [],
  LsAbstractResolutionConsultation: [],
};

const sannaReducer = createReducer(
  sannaInitialState,

  on(LOAD_SANNA_LICENCES, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_LICENCES_SUCCESS, (state, { lsRecordsWithoutProcessing }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsRecordsWithoutProcessing: [...lsRecordsWithoutProcessing],
  })),

  on(LOAD_SANNA_LICENCES_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_LICENCES_TO_DIGITIZE, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_LICENCES_TO_DIGITIZE_SUCCESS, (state, { lsRecords }) => ({
    ...state,
    loading: false,
    loaded: false,
    lsRecords: [...lsRecords],
  })),

  on(LOAD_SANNA_LICENCES_TO_DIGITIZE_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_LICENCES_TO_TYPE, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_LICENCES_TO_TYPE_SUCCESS, (state, { lsRecords }) => ({
    ...state,
    loading: false,
    loaded: false,
    lsRecords: [...lsRecords],
  })),

  on(LOAD_SANNA_LICENCES_TO_TYPE_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_LICENCES_CONSTANTS, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_LICENCES_CONSTANTS_SUCCESS, (state, { constants }) => ({
    ...state,
    loading: false,
    loaded: true,
    constants: [...constants],
  })),

  on(LOAD_SANNA_LICENCES_CONSTANTS_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_LICENSE, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_LICENSE_SUCCESS, (state, { license }) => ({
    ...state,
    loading: false,
    loaded: false,
    license: [...license],
  })),

  on(LOAD_SANNA_LICENSE_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_DIAGNOSTIC, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_DIAGNOSTIC_SUCCESS, (state, { diagnostics }) => ({
    ...state,
    loading: false,
    loaded: false,
    diagnostics: [...diagnostics],
  })),

  on(LOAD_SANNA_DIAGNOSTIC_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_CONTINGENCIES, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_CONTINGENCIES_SUCCESS, (state, { contingencies }) => ({
    ...state,
    loading: false,
    loaded: false,
    contingencies: [...contingencies],
  })),

  on(LOAD_SANNA_CONTINGENCIES_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(SELECT_SANNA_CONTINGENCIES, (state, { selectedContingencies }) => ({
    ...state,
    loading: false,
    loaded: false,
    selectedContingencies: { ...selectedContingencies },
  })),

  on(LOAD_SANNA_LICENCES_VALIDATION_ADMIN, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_LICENCES_VALIDATION_ADMIN_SUCCESS, (state, { lsRecordsValidationAdmin }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsRecordsValidationAdmin: [...lsRecordsValidationAdmin],
  })),

  on(LOAD_SANNA_LICENCES_VALIDATION_ADMIN_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_LICENCES_TO_VALIDATE, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_LICENCES_TO_VALIDATE_SUCCESS, (state, { lsValidationRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsValidationRecords: [...lsValidationRecords],
  })),

  on(LOAD_SANNA_LICENCES_TO_VALIDATE_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_MEDICAL_SPECIALITY, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_MEDICAL_SPECIALITY_SUCCESS, (state, { specialties }) => ({
    ...state,
    loading: false,
    loaded: true,
    specialties: { ...specialties },
  })),

  on(LOAD_MEDICAL_SPECIALITY_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT_SUCCESS, (state, { lsValidationComptrollerSupport }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsValidationComptrollerSupport: [...lsValidationComptrollerSupport],
  })),

  on(LOAD_SANNA_VALIDATION_COMPTROLLER_SUPPORT_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_VALIDATION_COMPTROLLER, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_VALIDATION_COMPTROLLER_SUCCESS, (state, { lsValidationComptroller }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsValidationComptroller: [...lsValidationComptroller],
  })),

  on(LOAD_SANNA_VALIDATION_COMPTROLLER_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_VALIDATION_PRESIDENT, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_VALIDATION_PRESIDENT_SUCCESS, (state, { lsValidationPresident }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsValidationPresident: [...lsValidationPresident],
  })),

  on(LOAD_SANNA_VALIDATION_PRESIDENT_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_ZONE_C, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_ZONE_C_SUCCESS, (state, { lsZoneC }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsZoneC: { ...lsZoneC },
  })),

  on(LOAD_SANNA_ZONE_C_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_DCN_REFERRER, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_DCN_REFERRER_SUCCESS, (state, { lsDcnReferrer }) => ({
    ...state,
    loading: false,
    loaded: true,
    lsDcnReferrer: [...lsDcnReferrer],
  })),

  on(LOAD_SANNA_DCN_REFERRER_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_PAYING_ENTITY_CONSULTATION, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_PAYING_ENTITY_CONSULTATION_SUCCESS, (state, { lsRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    LsPayingEntityConsultation: [...lsRecords],
  })),

  on(LOAD_SANNA_PAYING_ENTITY_CONSULTATION_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_PAYING_ENTITY_PROCESSING, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_PAYING_ENTITY_PROCESSING_SUCCESS, (state, { lsRecords }) => ({
    ...state,
    loading: false,
    loaded: true,
    LsPayingEntityProcessing: [...lsRecords],
  })),

  on(LOAD_SANNA_PAYING_ENTITY_PROCESSING_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),

  on(LOAD_SANNA_ABSTRACT_RESOL_CONSUL, (state) => ({
    ...state,
    loading: true,
  })),

  on(LOAD_SANNA_ABSTRACT_RESOL_CONSUL_SUCCESS, (state, { LsAbstractResolutionConsultation }) => ({
    ...state,
    loading: false,
    loaded: true,
    LsAbstractResolutionConsultation: [...LsAbstractResolutionConsultation],
  })),

  on(LOAD_SANNA_ABSTRACT_RESOL_CONSUL_FAIL, (state, { payload }) => ({
    ...state,
    loading: false,
    loaded: false,
    error: payload,
  })),
);

export function SannaReducer(state: SannaState, action: Action) {
  return sannaReducer(state, action);
}
